import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import AboutSection from "./components/AboutSection";
import GuidesSection from "./components/GuidesSection";
import ArticleSection from "./components/ArticleSection";
import FaqSection from "./components/FaqSection";
import { useSeo, getSiteUrl, DEFAULT_OG_IMAGE } from "@/hooks/useSeo";
import {
  useJsonLd,
  buildWebsiteSchema,
  buildOrganizationSchema,
  buildFaqSchema,
  FAVICON_URL,
} from "@/lib/schema";

const FAQ_IDS = ["1", "2", "3", "4", "5", "6", "7", "8"];

export default function Home() {
  const { t } = useTranslation();

  useSeo({
    title: t("home.meta.title"),
    description: t("home.meta.description"),
    keywords: t("home.meta.keywords"),
    path: "/",
    type: "website",
    image: DEFAULT_OG_IMAGE,
  });

  useJsonLd(
    "schema-website",
    buildWebsiteSchema(
      t("common.siteName"),
      getSiteUrl(),
      t("home.meta.description"),
    ),
  );

  useJsonLd(
    "schema-organization",
    buildOrganizationSchema(t("common.siteName"), getSiteUrl(), FAVICON_URL),
  );

  useJsonLd(
    "schema-faq",
    buildFaqSchema(
      FAQ_IDS.map((n) => ({
        q: t(`home.faq.q${n}`),
        a: t(`home.faq.a${n}`),
      })),
    ),
  );

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <AboutSection />
        <GuidesSection />
        <ArticleSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}